import React, { useState, useContext, useEffect, useCallback, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MuiTelInput } from 'mui-tel-input';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Autocomplete } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useNavigate, useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
// import CssTextField from './CssTextField';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import { FormControl, FormControlLabel } from '@mui/material';
import { FormGroup, Typography } from '@mui/material';
import { Checkbox, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';
import { getCourseImageDisplayUrlWithCleanup } from 'src/utils/imageUtils';
import UploadCourseImage from './Components/UploadCourseImage';

const AddCourse = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState();
  const [level, setLevel] = useState('primary-7-11');
  const [types, setType] = useState('online');
  const [isDateOpen, setIsDateOpen] = useState(false);

  const [isOngoing, setIsOngoing] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [selectedImages, setSelectedImages] = React.useState([]);
  const [snackBarSuccessOpen, setSnackBarSuccessOpen] = useState(false);

  const [subjects, setSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const debounceTimeoutRef = useRef(null);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [subject, setSubject] = useState('');
  const [availableLevels, setAvailableLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [imageDisplayData, setImageDisplayData] = useState({ url: '/assets/course-place.png', cleanup: () => {} });
  
  const [course, setCourse] = useState({
    name: '',
    subject: subject,
    level: '',
    date: '',
    time: '',
    duration: 'Duration of Advertising',
    addOne: '',
    addTwo: '',
    postCode: '',
    town: '',
    city: '',
    telephone: '',
    description: '',
    image: '',
    advPrice: '',
    coursePrice: '',
    file: '',
    email: '',
    socialLink: '',
    by: '',
    types: '',
    contactSources: '',
    userId: '',
    isOngoing: '',
  });

  const levels = [
    {
      value: 'primary-7-11',
      key: 'Primary (7/11+)',
    },
    {
      value: 'primary-5-11',
      key: 'Primary (5-11 yrs)',
    },
    {
      value: 'secondary-11-14',
      key: 'Seconday (11-14 yrs)',
    },
    {
      value: 'gcse-15-16',
      key: 'GCSE(15-16 yrs)',
    },
    {
      value: 'a-level-5-18',
      key: 'A-level (15-18 yrs)',
    },
    {
      value: 'degree-adults',
      key: 'Degree/Adults',
    },
    {
      value: 'other',
      key: 'Other',
    },
  ];

  const type = [
    { key: 'Online', value: 'online' },
    { key: 'In-Person', value: 'in-person' },
    { key: 'Summer', value: 'summer' },
    { key: 'Intensive', value: 'intensive' },
    { key: 'Discounts', value: 'discounts' },
    { key: 'PreSchool Age', value: 'preschool age' },
    { key: 'Primary Age', value: 'primary age' },
    { key: 'Secondary Age', value: 'secondary age' },
    { key: 'KS1', value: 'ks1' },
    { key: 'KS2', value: 'ks2' },
    { key: 'KS3', value: 'ks3' },
    { key: 'KS4', value: 'ks4' },
    { key: 'KS5', value: 'ks5' },
    { key: 'Reception', value: 'reception' },
    { key: 'GCSE', value: 'gcse' },
    { key: 'BTEC', value: 'btec' },
    { key: 'IB Internation Baccalaureate', value: 'iB internation baccalaureate' },
    { key: 'A-level', value: 'a-level' },
    { key: 'Degree', value: 'degree' },
    { key: 'Adult Learner', value: 'adult learner' },
    { key: 'Graduate', value: 'graduate' },
  ];

  const price = [
    { key: '1', value: '£4.99' },
    { key: '2', value: '£7.99' },
    { key: '6', value: '£12.99' },
    { key: '12', value: '£19.99' },
  ];

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER}/api/subjects`);
        setSubjects(response.data.subjects);
        setFilteredSubjects(response.data.subjects);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    fetchSubjects();
  }, []);

  const removeMUILicenseIssue = useCallback(() => {
    setTimeout(() => {
      const targetText = 'MUI X Missing license key';
      const divs = document.querySelectorAll('div');
      divs.forEach((div) => {
        if (div.textContent.trim() === targetText) {
          div.classList.add('hide');
          div.style.display = 'none';
        }
      });
    }, 100);
  }, []);

  useEffect(() => {
    if (isDateOpen) {
      removeMUILicenseIssue();
    }
  }, [isDateOpen, removeMUILicenseIssue]);
  const handleDateChange = (newValue) => {
    setCourse((prevCourse) => {
      const updatedCourse = {
        ...prevCourse,
        date: newValue,
      };

      if (prevCourse.isOngoing === 'On-going' && Array.isArray(updatedCourse.date)) {
        let filteredDates = updatedCourse.date.filter((_, index) => index !== 1);
        if (filteredDates.length === 1 && filteredDates[0] === null) {
          filteredDates = [];
        }
        updatedCourse.date = filteredDates;
      }

      return updatedCourse;
    });
  };

  const getSingleCourseData = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER}/api/courses/${id}`);
      if (response && response.data.length > 0) {
        const courseData = response.data[0];
        const { date, time, ...filteredCourseData } = courseData;
        filteredCourseData.date = [dayjs(date[0]), dayjs(date[1])];
        setCourse({ ...filteredCourseData });
        setLevel(filteredCourseData.level);
      }
    } catch (error) {
      console.error('Error in fetching Course', error);
    }
  }, [id]);
  useEffect(() => {
    if (id) getSingleCourseData();
  }, [getSingleCourseData, id]);

  const createCourse = async (course) => {
    const cookies = new Cookies();
    const token = cookies.get('admin_token');
    const user = jwtDecode(token);
    const userId = user._id;

    const formData = new FormData();
    if (typeof course.image !== 'string') {
      formData.append('image', course.image);
    } else {
      delete course.image;
    }
    if (typeof course.file !== 'string') {
      formData.append('file', course.file);
    } else {
      delete course.file;
    }
    formData.append(
      'courseData',
      JSON.stringify({
        ...course,
        token,
        userId,
      })
    );

    try {
      let response;
      if (id) {
        response = await axios.put(`${process.env.REACT_APP_SERVER}/api/courses/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        response = await axios.post(`${process.env.REACT_APP_SERVER}/api/courses`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        });
      }
      console.log('response', response);
      if (response) {
        setSnackBarSuccessOpen(true);
        
        setTimeout(() => {
          navigate('/course');
        }, 2000);
      }
      setLoading(false);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Your message could not be sent, please try again!';
      setLoading(false);
    }
  };
  const handleClickSnack = () => {
    setSnackBarOpen(true);
  };

  const handleCloseSuccessSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarSuccessOpen(false);
  };



  const handleOnGoingChange = (event) => {
    setIsOngoing(event.target.checked);
    const isChecked = event.target.checked;

    console.log(typeof course.date);
    console.log(course.date);

    setCourse((prevCourse) => {
      const updatedCourse = {
        ...prevCourse,
        isOngoing: isChecked ? 'On-going' : 'Not On-going',
      };

      if (Array.isArray(prevCourse.date)) {
        const filteredDates = prevCourse.date.filter((_, index) => index !== 1);
        console.log(filteredDates);
        updatedCourse.date = filteredDates;
      }

      console.log(updatedCourse.date);
      console.log(updatedCourse.name);

      return updatedCourse;
    });
  };

  const fileInputRef = useRef(null);


  const handleCheckboxChange = (event) => {
    const { value } = event.target;

    setCourse((prevCourse) => {
      const updatedTypes = prevCourse.types.includes(value)
        ? prevCourse.types.filter((type) => type !== value)
        : [...prevCourse.types, value];

      const shouldShowAddress = updatedTypes.includes('in-person');
      setShowAddress(shouldShowAddress);

      return { ...prevCourse, types: updatedTypes };
    });
  };

  const handleContactCheckboxChange = (event) => {
    const { value } = event.target;

    setCourse((prevCourse) => {
      const updatedContactSources = prevCourse.contactSources.includes(value)
        ? prevCourse.contactSources.filter((source) => source !== value)
        : [...prevCourse.contactSources, value];
      return { ...prevCourse, contactSources: updatedContactSources };
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let newError = {};

    if (course.name.trim().length === 0) newError.name = 'Please input Course Name.';
    if ((!course?.date?.length || course.date.length === 0) && course.isOngoing.length === 0)
      newError.date = 'Please input Course Date or Select OnGoing';
    if (course.duration.trim().length === 0) newError.duration = 'Please input Course Duration.';
    // if (course.types.trim().length === 0) newError.type = 'Please select Course Type.';
    if (!course.file) newError.file = 'Please upload a PDF file.';
    if (!course.image) newError.image = 'Please upload an image.';
    if (course.advPrice.trim().length === 0) newError.advPrice = 'Please Select a Package.';
    if (course.types === 'In-Person' && course.addOne.length === 0) newError.address = 'Please Enter Address';
    if (course.contactSources.includes('email') && course.email.trim().length === 0)
      newError.email = 'Please Enter Email';
    if (course.contactSources.includes('phone') && course.telephone.trim().length === 0)
      newError.telephone = 'Please Enter Telephone';
    if (course.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(course.email)) {
        newError.email = 'Please enter a valid email address.';
      }
    }
    if (course.contactSources.length === 0) newError.contactSources = 'Please select a contact source.';
    setError(newError);

    if (Object.keys(newError).length > 0) return;
    setLoading(true);
    createCourse(course);
  };

  const handlePhoneNumber = (newValue) => {
    setCourse({ ...course, telephone: newValue });
  };
  const handleSubjectInputChange = async (value) => {
    if (value.length === 0) {
      setFilteredSubjects(subjects);
      setSelectedLevel('');
    } else if (value.length > 2) {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }

      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_SERVER}/api/subjects?search=${value}`);
          const subjectsData = response.data.subjects;
          setFilteredSubjects(subjectsData);
        } catch (error) {
          console.error('Error fetching filtered subjects:', error);
        }
      }, 300);
    }
  };

  
  useEffect(() => {
    return () => {
      imageDisplayData.cleanup();
    };
  }, [imageDisplayData]);
  
  useEffect(() => {
    if (course?.image) {
      const displayData = getCourseImageDisplayUrlWithCleanup(course.image);
      setImageDisplayData(displayData);
    } else {
      setImageDisplayData({ url: '/assets/course-place.png', cleanup: () => {} });
    }
  }, [course?.image]);
  
  return (
    <div className="contact-container">
      <div className="contact bd-grey">
        <div className="page-heading" style={{ marginBottom: '20px' }}>
          <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Open Sans', fontWeight: '600', m: 1 }}>
            {id ? 'Update Course' : 'Add New Course'}
          </Typography>
        </div>
        <Box
          component="form"
          className="boxx"
          onSubmit={handleSubmit}
          sx={{
            '& .MuiTextField-root': { maxWidth: '100%' },
            '& .captcha': { m: 1, mt: 2 },
            '& .submitbtn': { m: 1, mt: 4 },
            '& .heading': { m: 1, textAlign: 'center' },
          }}
          noValidate
          autoComplete="off"
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <div className="form" style={{ width: '100%' }}>
            <div>
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  required
                  id="name-of-course"
                  label="Name of course/class"
                  value={course?.name}
                  onChange={(e) => setCourse({ ...course, name: e.target.value })}
                  style={{
                    height: '50px',
                    width: '100%',
                    margin: '0px',
                  }}
                />
                {error.name && <span style={{ color: 'red', paddingLeft: '10px' }}>{error.name}</span>}
                <div
                  className="subject-level-row"
                  style={{
                    display: 'flex',
                    gap: '40px',
                    marginTop: '20px',
                    marginBottom: '20px',
                    flexWrap: 'wrap',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Autocomplete
                      className="subject-autocomplete"
                      value={selectedSubject}
                      onInputChange={(_, value) => handleSubjectInputChange(value)}
                      onChange={(_, value) => {
                        setSelectedSubject(value || '');
                        setSubject(value || '');
                        setCourse((prev) => ({
                          ...prev,
                          subject: value || '',
                        }));
                        const selected = subjects.find((s) => s.name === value);
                        setAvailableLevels(selected?.levels || []);
                        setSelectedLevel('');
                        setLevel('');
                      }}
                      options={filteredSubjects.map((s) => s.name)}
                      renderInput={(params) => (
                        <TextField {...params} label="Subject" variant="outlined" fullWidth size="medium" />
                      )}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <TextField
                      className="subject-level-dropdown"
                      select
                      label="Level"
                      value={selectedLevel}
                      onChange={(e) => {
                        setSelectedLevel(e.target.value);
                        setLevel(e.target.value);
                      }}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      disabled={availableLevels.length === 0}
                    >
                      {availableLevels.length === 0 ? (
                        <MenuItem value="Not needed">Not Needed</MenuItem>
                      ) : (
                        availableLevels.map((level) => (
                          <MenuItem key={level} value={level}>
                            {level}
                          </MenuItem>
                        ))
                      )}
                    </TextField>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: '20px', marginTop: '10px!important' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateRangePicker
                    required
                    localeText={{ start: 'Start Date', end: isOngoing ? 'On Going' : 'End Date' }}
                    id="date-of-course"
                    label="Date Of Course"
                    value={course.date ?? []}
                    onChange={handleDateChange}
                    onOpen={() => {
                      if (!isOngoing) {
                        setIsDateOpen(true);
                      } else {
                        setIsDateOpen(false);
                      }
                      removeMUILicenseIssue();
                    }}
                    onClose={() => setIsDateOpen(false)}
                    style={{ width: '100%' }}
                    slotProps={{
                      textField: ({ position }) => ({
                        disabled: isOngoing && position === 'end',
                      }),
                    }}
                    disabled={isOngoing && course.date.length > 0 && course.date[0]}
                  />
                </LocalizationProvider>
                {error.date && <span style={{ color: 'red' }}>{error.date}</span>}
                <div className="on-going">
                  <FormControl component="fieldset">
                    <FormGroup row>
                      <FormControlLabel
                        control={<Checkbox checked={isOngoing} onChange={handleOnGoingChange} name="on-going" />}
                        label="On-going"
                      />
                    </FormGroup>
                  </FormControl>
                </div>
                <div style={{ width: '100%' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      id="time-of-course"
                      label="Time Of Course"
                      onChange={(time) => setCourse({ ...course, time })}
                      style={{
                        width: '100%',
                        marginTop: '20px',
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <FormControl component="fieldset">
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={course?.types?.includes('in-person')}
                        onChange={handleCheckboxChange}
                        value="in-person"
                      />
                    }
                    label="In-Person"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={course?.types?.includes('online')}
                        onChange={handleCheckboxChange}
                        value="online"
                      />
                    }
                    label="Online"
                  />
                </FormGroup>
              </FormControl>

              {showAddress && (
                <div style={{ marginTop: '10px' }}>
                  <TextField
                    required
                    fullWidth
                    label="Address Line 1"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setCourse({ ...course, addOne: e.target.value })}
                  />
                  {error.address && <span style={{ color: 'red' }}>{error.address}</span>}
                  <TextField
                    fullWidth
                    label="Address Line 2 (optional)"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setCourse({ ...course, addTwo: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    label="Town (optional)"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setCourse({ ...course, town: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    label="City (optional)"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setCourse({ ...course, city: e.target.value })}
                  />
                  <TextField
                    required
                    fullWidth
                    label="Postcode"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setCourse({ ...course, postCode: e.target.value })}
                  />
                </div>
              )}
              <TextField
                id="price-of-course"
                label="Course Price"
                value={course?.coursePrice}
                onChange={(e) => setCourse({ ...course, coursePrice: e.target.value })}
                InputProps={{
                  startAdornment: <InputAdornment position="start">£</InputAdornment>,
                }}
                style={{
                  width: '100%',
                  marginBottom: '20px',
                  boxSizing: 'border-box',
                  height: '50px',
                }}
              />

              <Box sx={{ marginBottom: '10px' }}>
                <label className="des">Description</label>
                <Box sx={{ paddingTop: '10px' }}></Box>
                <CKEditor
                  editor={ClassicEditor}
                  data={course?.description || ''}
                  config={{
                    licenseKey:
                      'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NzI2Njg3OTksImp0aSI6ImJhZWIyYmVjLTAxZGUtNDMzOC05OGE5LTA0YTE4NWRiNGZhMiIsInVzYWdlRW5kcG9pbnQiOiJodHRwczovL3Byb3h5LWV2ZW50LmNrZWRpdG9yLmNvbSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsiY2xvdWQiLCJkcnVwYWwiXSwiZmVhdHVyZXMiOlsiRFJVUCJdLCJ2YyI6ImIyNjQ2Yjk4In0.mDFtds_qKytOAomjY7QqkV5ITvFS1gFwMFf31OQcZQIgeJOvzhRuiiMCwX6pUbqRNpnXlWdCzD_WcjVGxfYjXQ', // 👈 Add this
                    height: '20vh',
                    styles: {
                      height: '500px',
                    },
                    toolbar: ['bold', 'list', 'bulletedList', 'numberedList'],
                    placeholder: 'Write a clear description about the course or class you are offering',
                    lists: {
                      numbered: true,
                      bulleted: true,
                    },
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCourse((prevCourse) => ({
                      ...prevCourse,
                      description: data,
                    }));
                  }}
                />
              </Box>
              <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                <label
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  Upload File
                  <span
                    style={{
                      fontWeight: 'normal',
                      fontSize: '15px',
                      paddingTop: '5px',
                      paddingBottom: '5px',
                    }}
                  >
                    Upload information about your course/class for users to download.
                  </span>
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setCourse({ ...course, file: e.target.files[0] })}
                  style={{ width: '100%' }}
                />
                {error.file && <span style={{ color: 'red' }}>{error.file}</span>}
              </div>
              <UploadCourseImage
                course={course}
                setCourse={setCourse}
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
                error={error}
                imageDisplayData={imageDisplayData}
                setImageDisplayData={setImageDisplayData}
              />
              <TextField
                id="social-link"
                label="Add Your Website (optional)"
                value={course.socialLink}
                onChange={(e) => setCourse({ ...course, socialLink: e.target.value })}
                style={{
                  width: '100%',
                  marginBottom: '20px',
                  boxSizing: 'border-box',
                  height: '50px',
                }}
              />
              <TextField
                id="by"
                label="Course by (optional)"
                value={course.by}
                onChange={(e) => setCourse({ ...course, by: e.target.value })}
                style={{
                  width: '100%',
                  marginBottom: '20px',
                  boxSizing: 'border-box',
                  height: '50px',
                }}
              />
              <div style={{ marginTop: '20px' }}>
                <span
                  style={{
                    fontWeight: 'normal',
                    fontSize: '15px',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                  }}
                >
                  Select the form of communication through which potential clients can get in touch with you. This can
                  be via telephone, email, or our message system. You must select at least one method.
                </span>
                <br />
                <div
                  style={{
                    fontWeight: 'normal',
                    fontSize: '15px',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                  }}
                >
                  Tick which way you would like other to get in touch with you
                </div>
                <FormControl component="fieldset">
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={course?.contactSources?.includes('email')}
                          onChange={handleContactCheckboxChange}
                          value="email"
                        />
                      }
                      label="Email"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={course?.contactSources?.includes('phone')}
                          onChange={handleContactCheckboxChange}
                          value="phone"
                        />
                      }
                      label="Phone"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={course?.contactSources?.includes('our-message-system')}
                          onChange={handleContactCheckboxChange}
                          value="our-message-system"
                        />
                      }
                      label="Our message system"
                    />
                  </FormGroup>
                </FormControl>
                {error.contactSources && (
                  <>
                    <br />
                    <span style={{ color: 'red' }}>{error.contactSources}</span>
                  </>
                )}
              </div>
              {course.contactSources.includes('email') && (
                <TextField
                  id="social-link"
                  label="Please add your email for contact"
                  value={course.email}
                  onChange={(e) => setCourse({ ...course, email: e.target.value })}
                  style={{
                    width: '100%',
                    marginTop: '20px',
                    boxSizing: 'border-box',
                    height: '50px',
                  }}
                />
              )}
              {error.email && <span style={{ color: 'red' }}>{error.email}</span>}
              {course.contactSources.includes('phone') && (
                <MuiTelInput
                  id="telephone"
                  label="Telephone"
                  value={course.telephone}
                  onChange={handlePhoneNumber}
                  defaultCountry="GB"
                  style={{
                    width: '100%',
                    marginBottom: '20px',
                    marginTop: '20px',
                  }}
                />
              )}
              {error.telephone && <span style={{ color: 'red' }}>{error.telephone}</span>}
              <div>
                <Select
                  required
                  id="demo-simple-select"
                  value={course.duration}
                  onChange={(e) => {
                    const selectedOption = price.find((option) => option.key === e.target.value);
                    setCourse({
                      ...course,
                      advPrice: selectedOption.value,
                      duration: selectedOption.key,
                    });
                  }}
                  displayEmpty
                  renderValue={(value) => {
                    return (
                      price.find((el) => el.key === value)?.value ?? (
                        <span style={{ color: '#6F6E70' }}>Duration Of advertising</span>
                      )
                    );
                  }}
                  style={{ width: '100%', marginTop: '20px' }}
                  error={error.duration}
                  helperText={error.duration}
                >
                  {price.map(({ key, value }) => (
                    <MenuItem key={key} value={key}>
                      {key === '1' ? `${key} Month` : key === '12' ? 'Year' : `${key} Months`} ({value})
                    </MenuItem>
                  ))}
                </Select>
                {error.advPrice && <span style={{ color: 'red' }}>{error.advPrice}</span>}
              </div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="submitbtn"
                style={{
                  marginTop: '20px',
                  marginLeft: '0px',
                  backgroundColor: '#712d93',
                  color: '#fff',
                  padding: '10px 20px',
                  fontSize: '16px',
                }}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
              </Button>
            </div>
          </div>
        </Box>
        <Snackbar
          open={snackBarSuccessOpen}
          autoHideDuration={3000}
          onClose={handleCloseSuccessSnack}
          message={id ? "Course Updated Successfully!" : "Course Created Successfully!"}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          sx={{
            '& .MuiSnackbarContent-root': {
              backgroundColor: '#4caf50',
              color: 'white',
              fontWeight: 'bold'
            }
          }}
        />

      </div>
    </div>
  );
};

export default AddCourse;
